import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-worldpay-layout',
  templateUrl: './worldpay-layout.component.html',
  styleUrls: ['./worldpay-layout.component.css']
})
export class WorldpayLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
